import request from '@/axios/request.js'

/**
 * 积分商城接口。
 * 积分商品、积分明细和积分订单均复用商城现有 App 端接口。
 */
export function getIntegralProducts (params) {
  return request({
    url: '/api/products-integral',
    method: 'get',
    params
  })
}

export function getIntegralProductDetail (id) {
  return request({
    url: '/api/products-detailIntegral',
    method: 'get',
    params: { id }
  })
}

export function getIntegral () {
  return request({
    url: '/api/getIntegral',
    method: 'get'
  })
}

export function getIntegralLimit () {
  return request({
    url: '/api/getIntegralLimit',
    method: 'get'
  })
}

export function getIntegralList (params) {
  return request({
    url: '/api/integral/list',
    method: 'get',
    params
  })
}

/**
 * 将积分商品加入兑换购物车，后端会继续校验商品、库存和积分资格。
 */
export function addIntegralCart (data) {
  return request({
    url: '/api/cart/add',
    method: 'post',
    data
  })
}
